import { Node } from './Node';
/**
 * An Operator saves the state of a combined query
 */
export class Operator extends Node {
    /**
     * @param entityManager The owning entity manager of this query
     * @param resultClass The query result class
     * @param operator The operator used to join the childes
     * @param childes The childes to join
     */
    constructor(entityManager, resultClass, operator, childes) {
        super(entityManager, resultClass);
        this.operator = operator;
        this.childes = childes;
    }
    toJSON() {
        const json = {};
        json[this.operator] = this.childes;
        return json;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3BlcmF0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJPcGVyYXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBSTlCOztHQUVHO0FBQ0gsTUFBTSxPQUFPLFFBQTJCLFNBQVEsSUFBTztJQVdyRDs7Ozs7T0FLRztJQUNILFlBQVksYUFBNEIsRUFBRSxXQUFxQixFQUFFLFFBQWdCLEVBQUUsT0FBa0I7UUFDbkcsS0FBSyxDQUFDLGFBQWEsRUFBRSxXQUFXLENBQUMsQ0FBQztRQUNsQyxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztRQUN6QixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztJQUN6QixDQUFDO0lBRUQsTUFBTTtRQUNKLE1BQU0sSUFBSSxHQUFzQyxFQUFFLENBQUM7UUFDbkQsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDO1FBQ25DLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztDQUNGIn0=